// extracted by mini-css-extract-plugin
module.exports = {"details":"DetailedRowView_details__1NET5"};